module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab1href,
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.openShopStats()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('Average rating for Shops')) + "\n            ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab2href,
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.openComments()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('Comments')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab1ID
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('table', {
    staticClass: "table table-condensnd"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.t('Shop')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Number of ratings')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Average rating')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Range')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.stats), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.shop_name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rate))]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(item.down) + " - " + _vm._s(item.up) + "\n                                ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [_c('default-chart', {
    attrs: {
      "labels": _vm.chart.labels,
      "items": _vm.chart.items,
      "height": 120
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab2ID
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "control-group"
  }, [_c('div', {
    staticClass: "controls form-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedProduct),
      expression: "selectedProduct"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedProduct = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.dataTableRefresh = !_vm.dataTableRefresh
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.t('Select single product')))]), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('option', {
      domProps: {
        "value": product.id
      }
    }, [_vm._v(_vm._s(product.shop_name) + " - " + _vm._s(product.name))])
  })], 2), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "from-placeholder": _vm.t('From'),
      "to-placeholder": _vm.t('To'),
      "from-disabled": _vm.fromDisabled,
      "to-disabled": _vm.toDisabled
    },
    on: {
      "input": _vm.selectedDate
    },
    model: {
      value: (_vm.datepicker),
      callback: function($$v) {
        _vm.datepicker = $$v
      },
      expression: "datepicker"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    attrs: {
      "id": 'datatable-' + _vm.getTableId() + '-length-box'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    attrs: {
      "id": 'datatable-' + _vm.getTableId() + '-search-box'
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('data-table', {
    attrs: {
      "dt-id": _vm.getTableId(),
      "length-handle": '#datatable-' + _vm.getTableId() + '-length-box',
      "columns": _vm.columns,
      "refresh": _vm.dataTableRefresh,
      "my-ajax": _vm.dataTableAjax,
      "search": {
        handle: '#datatable-' + _vm.getTableId() + '-search-box',
        placeholder: _vm.t('Search content')
      },
      "sort": true
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d9ac306!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductReviewDetail.vue
// module id = 1331
// module chunks = 2